import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { of, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ResumenData } from '../../../../../../core/model/DataCart';
import { ProductData } from '../../../../../../core/model/Product.model';
import { EventService } from '../../../../../../services/event.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { DialogConfirmComponent } from '../../dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-resumen-responsive',
  templateUrl: './resumen-responsive.component.html',
  styleUrls: ['./resumen-responsive.component.scss']
})
export class ResumenResponsiveComponent implements OnInit {
  public resumen: ResumenData = null;
  public cantidadProduct: number;
  public ocultare: boolean = true;
  private unsubscribe$ = new Subject<void>();
  private precioPaqueteria: number = 0;
  public products: ProductData[];

  constructor(
    private cartService: CartService,
    private dialogConfirm: MatDialog,
    private login: LoginService,
    private eventService: EventService
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.dataCart();
    this.cartService.resumen$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      this.resumen = data;
      localStorage.setItem('resumen-cart-login', JSON.stringify(data));
    });
    this.getProductsCart();
  }

  private getProductsCart = () => {
    this.products = JSON.parse(localStorage.getItem('items-cart-login'));
  }

  public dataCart = (): void => {
    console.group('Start mini cart', this.precioPaqueteria);
    let cartResumen;
    this.cartService.cart$.pipe(
      takeUntil(this.unsubscribe$),
      switchMap((resumen) => {
        if (resumen) {
          this.cantidadProduct = resumen.length;
          cartResumen = resumen;
          this.resumen = this.cartService.calcularResumen(cartResumen);
          return this.cartService.precioEnvio$;
        }
        return of(null);
        //      Retornamos el servicio del carrito
      })
    ).subscribe((precioEnvio: number) => {
      this.precioPaqueteria = precioEnvio;
      if (this.login.isLogged()) { // SI es publico general o no esta lo9gueado colocarle el precio de paqueteria
        if (this.login.getDataClientePedido().es_publicogeneral === 'SI') {
          localStorage.setItem('envio-cart-login', String(this.precioPaqueteria));
        }
      } else {
        localStorage.setItem('envio-cart-login', String(this.precioPaqueteria));
      }
      this.resumen = this.cartService.calcularResumen(cartResumen);
    });
    console.groupEnd();
  }

  public deleteCart = () => {
    const dialogRes = this.dialogConfirm.open(DialogConfirmComponent, {
      // width: '55vh',
      data: {
        title: '¿Estas seguro que deseas vaciar tu cesta?',
        text: '',
        subtext: '',
        btnPrimaryText: 'Sí, Vaciar',
        btnSecondText: 'No, Cancelar',
        classCancelSecond: true,
        classbtnSecond: true,
        showCancel: true,
        classCustomText: ''
      }
    });
    dialogRes.afterClosed().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
      if (response) {
        if (this.login.isLogged()) {
          this.cartService.deleteCart();
        } else {
          this.cartService.deleteCartIsNotLoguin(); //vaciar cesta cuano no ha iniciado session
        }
        localStorage.removeItem('resumen-cart-login');
        localStorage.removeItem('data-pedido');
        localStorage.removeItem('carrito');
        localStorage.removeItem('items-cart-login');
        localStorage.removeItem('comision-cart-login');
        localStorage.removeItem('pasarela-pago');
        localStorage.removeItem('envio-cart-login');
        localStorage.removeItem('data-operation');
      }
    });
  }

  ocultar() {
    this.ocultare = !this.ocultare;
    this.eventService.send("hidden", this.ocultare);
  }
}
